import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import noCourse from '../../../public/assets/noCourse.svg';
import noStudyPlan from '../../../public/assets/study-nodata.png';
import futureDate from '../../../public/assets/futureDateBanner.png';

// eslint-disable-next-line react/prop-types
function NoDataFound({ noMsg, pageType, tagName }) {
  return (
    <div className="flex justify-center items-center bg-white h-full w-full  border border-[#B8E5FF]">
      { pageType !== 'Study Plan' ? (
        <div className="text-red-600 text-center py-6 px-2 bg-white rounded-md w-full flex justify-center items-center flex-col">
          <Image width={140} height={160} src={noCourse} className="inline-block mb-2 lg:w-40 w-36" alt="NoCourseFound" />
          <h3 className="text-lg font-semibold text-[#334155]">Oops!</h3>
          <p className="text-sm font-normal text-[#334155]">{noMsg}</p>
        </div>
      ) : (
        <div>
          {
          tagName === 'FutureDate' ? (
            <div className="text-red-600 text-center py-6 flex justify-center items-center flex-col">
              <Image width={500} height={500} src={futureDate} className="inline-block mb-2 lg:w-40 w-36" alt="future Date" />
              <div>
                <p className="text-sm font-normal text-[#334155]">
                  {noMsg}
                </p>
              </div>
            </div>
          ) : (
            <div className="text-red-600 text-center py-6 flex justify-center items-center flex-col">
              <Image width={500} height={500} src={noStudyPlan} className="inline-block mb-2 lg:w-40 w-36" alt="NoCourseFound" />
              <h3 className="text-lg font-semibold text-[#334155]">Oops!</h3>
              <div>
                <p className="text-sm font-normal text-[#334155]">
                  {noMsg}
                  {' '}
                </p>
              </div>
            </div>
          )
        }
        </div>
      )}
    </div>
  );
}

NoDataFound.propTypes = {
  noMsg: PropTypes.any,
  tagName: PropTypes.string,
};

export default NoDataFound;
